export const COLORS = {
  navy: "#0F2C59",
  slate: "#475569",
  KESIN: "#10B981",
  BELKI: "#F59E0B",
  KARSI: "#EF4444",
  GELMEYECEK: "#94A3B8",
  ULASILAMADI: "#64748B",
  cyan: "#0EA5E9",
  BIZ: "#10B981",
  GELEMEDI: "#F59E0B",
};

export const PREDICTION_LABELS = {
  KESIN: "Kesin",
  BELKI: "Belki",
  GELMEYECEK: "Gelmeyecek",
  ULASILAMADI: "Ulaşılamadı",
  KARSI: "Karşı",
};

export const PREDICTION_OPTIONS = ["KESIN", "BELKI", "GELMEYECEK", "ULASILAMADI", "KARSI"];
// Filtre listelerinde ayrıca hiç işaretlenmemiş kayıtlar seçilebilir
export const PREDICTION_FILTER_OPTIONS = [...PREDICTION_OPTIONS, "BOS"];

// Excel "Eğilim (1-5)" karşılıkları — kullanıcı kolaylığı için etikette parantez içinde gösterilir.
export const PREDICTION_LABELS_NUM = {
  KESIN: "Kesin (5)",
  BELKI: "Belki (4)",
  GELMEYECEK: "Gelmeyecek (3)",
  ULASILAMADI: "Ulaşılamadı (3)",
  KARSI: "Karşı (1-2)",
  BOS: "İşaretsiz",
};

export const VOTE_2022_LABELS = { BIZ: "Biz", GELEMEDI: "Gelemedi", KARSI: "Karşı" };
export const VOTE_2022_OPTIONS = ["BIZ", "GELEMEDI", "KARSI"];

export const STATUS_LABELS = { faal: "FAAL", aski: "ASKI" };
export const STATUS_OPTIONS = ["faal", "aski"];

export const SECTORS = ["Dalgıç", "İnşaat", "Römorkör", "Tersane", "Tarama", "Tamir", "İmalat", "Proje", "Çevre", "Diğer"];
export const BRANCHES = ["Merkez", "İzmir", "Kocaeli", "Yalova", "Çanakkale", "Rize", "Samsun", "Gemlik"];

export const ROLE_LABELS = {
  super_admin: "Genel Yönetici",
  committee_manager: "Komite Yöneticisi",
  field_agent: "Saha Görevlisi",
  chairman: "Başkan",
  branch_manager: "Şube Yöneticisi",
};

// Kullanıcıya atanabilir 9 şube ("Kdz. Ereğli" verisi "Karadeniz Ereğli" olarak baz alınır).
export const ASSIGNABLE_BRANCHES = ["Aliağa", "Antalya", "Bodrum", "Fethiye", "İskenderun", "İzmir", "Karadeniz Ereğli", "Kocaeli", "Marmaris"];

export const VOTER_TYPE_LABELS = { is_same: "AYNI", is_new: "YENİ" };

export function predColor(k) {
  return COLORS[k] || COLORS.slate;
}

// Şube seçim tarihleri (her şube farklı gün). Belirtilmeyen şubeler için tarih yok.
export const BRANCH_ELECTION_DATES = {
  "Kocaeli": "2026-10-01",
  "Karadeniz Ereğli": "2026-10-01",
  "Bodrum": "2026-10-03",
  "Fethiye": "2026-10-04",
  "Aliağa": "2026-10-05",
  "İzmir": "2026-10-08",
  "Marmaris": "2026-10-10",
};

const _TR_MONTHS = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];

export function branchElectionLabel(dateStr) {
  if (!dateStr) return "Belirlenmedi";
  const d = new Date(dateStr + "T08:00:00+03:00");
  return `${d.getDate()} ${_TR_MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function branchDaysLeft(dateStr) {
  if (!dateStr) return null;
  const ms = new Date(dateStr + "T08:00:00+03:00").getTime() - Date.now();
  return ms <= 0 ? 0 : Math.ceil(ms / 86400000);
}
